<!--DialogHeader-->
<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-toolbar dense flat>
        <v-toolbar-title class="text-md-h6 text-sm-h6">
          {{ title || 'No title' }}
        </v-toolbar-title>
        <template v-if="!isPhoneBool">
          <v-spacer />
          <v-divider vertical class="mr-1" v-if="expandable || closable" />
          <v-btn v-if="expandable" icon small class="mx-2" @click="expand">
            <v-icon v-text="expanded ? 'mdi-arrow-collapse' : 'mdi-arrow-expand'"></v-icon>
          </v-btn>
          <v-btn v-if="closable" icon small @click="$emit('Close')">
            <v-icon v-text="'mdi-close'" />
          </v-btn>
        </template>
      </v-toolbar>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "DialogHeader",
  props: {
    title: String,
    expanded: Boolean,
    expandable: {
      default: true,
      type: Boolean,
    },
    closable: {
      default: true,
      type: Boolean,
    },
  },
  model: {
    prop: "expanded",
    event: "resize",
  },
  methods: {
    expand() {
      this.$emit("resize", !this.expanded);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>